import React from "react";

export default function SQL_Server() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">SQL_Server</h1>
      <p>This is the SQL_Server component generated from the SQL JSON.</p>
    </div>
  );
}
